/**
 * Cálculo del dígito de verificación del NIT colombiano (misma lógica que Canal_Ventas).
 * El usuario ingresa solo los primeros 9 dígitos; el décimo se calcula con este algoritmo.
 */
export function calcularDigitoVerificacionNIT(nit: string): string {
  if (nit == null || nit === '') return '';
  const vpri = [0, 3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71];
  const s = String(nit).replace(/\D/g, '');
  const z = s.length;
  let x = 0;
  for (let i = 0; i < z; i++) {
    x += parseInt(s.charAt(i), 10) * vpri[z - i];
  }
  const y = x % 11;
  return String(y > 1 ? 11 - y : y);
}
